export default __webpack_public_path__ + "static/media/1_3.27d51ef3.jpg";